const translations = {
  AdminAddTeacher: {
    username: 'Email'
  },
  AdminUserProfile: {
    username: 'Email/Username'
  },
  AssignmentMenu: {
    CurrentAssignments: 'Current'
  },
  DemolinkLauncherView: {
    demoUserFirstName: 'Demo',
    demoUserLastName: 'Teacher',
  },
  EditStudentProfile: {
    username: 'Email/Username'
  },
  Login: {
    buttonSignUpLabel: 'Sign Up',
    emailPlaceholder: 'Teacher Email or Student Username',
    loginLogoLabel: 'Logo: Ballard & Tighe',
    username: 'Teacher Email/Student Username'
  },
  ProgressView: {
    WeeklyPerformanceLabel: 'Weekly Achievement'
  },
  Register: {
    emailPlaceholder: 'Teacher Email or Student Username',
    username: 'Teacher Email/Student Username'
  },
  RegisterInvite: {
    emailPlaceholder: 'Teacher Email or Student Username',
    username: 'Teacher Email/Student Username'
  },
  RegisterStudentModal: {
    emailLabel: 'Teacher Email/Student Username'
  },
  StudentDashboard: {
    BookLabel: 'My Content'
  },
  StudentTopNav: {
    BookLabel: 'My Content'
  },
  TeacherDashboard: {
    WelcomeLabel: 'Welcome,'
  }
};

export default translations;
